import { useCallback, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCaretLeft } from '@fortawesome/free-solid-svg-icons/faSquareCaretLeft';
import { SkuReportGridData } from '@pages/reporting-pages/deliveries-sku/types/SkuReportGridData';
import useSkuClick from '@hooks/reportings/useSkuClick';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { renderLitresToHL } from 'components/global/utils';



interface GridRowProps {
	item: SkuReportGridData,
	rowIndex: number,
	dateFrom: string,
	dateTo: string,
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex, dateFrom, dateTo } = props;
	const { country, materialClientId, materialName, totalVolume, onTradeVolume, offTradeVolume } = props.item;

	const hasPermission = useHasPermission();
	const skuClick = useSkuClick({ dateFrom, dateTo, materialClientId });

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				{hasPermission(AppRolesEnum.countryDeliveriesSkuReportDcDetail_Read) &&
					<FontAwesomeIcon className='order-link-icon' icon={faSquareCaretLeft} onClick={skuClick} />}
			</div>

			<div className={getClassName(true)}>
				<p>{country}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{materialClientId}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{materialName}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderLitresToHL(totalVolume)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderLitresToHL(onTradeVolume)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderLitresToHL(offTradeVolume)}</p>
			</div>
		</>
	)
}

export default memo(GridRow);